"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonBase = void 0;
const Box_1 = require("./Box");
exports.ButtonBase = Box_1.Box.withComponent('button');

//# sourceMappingURL=ButtonBase.js.map
